import React from 'react';
import SLinkButton from '../styled/SLinkButton';
import { ButtonColor } from '../button/Button';
import styled from 'styled-components';

export interface ILinkButtonProps {
  className?: string;
  onClick?: React.MouseEventHandler;
  disabled?: boolean;
  dataAt?: string;
  color?: ButtonColor;
  bold?: boolean;
}

// tslint:disable-next-line:variable-name
const LinkButton: React.SFC<ILinkButtonProps> = (props) => (
  <SLinkButton tabIndex={0} type="button" color={props.color || ButtonColor.light} disabled={props.disabled || false} {...props} data-at={props.dataAt}>
    {props.children}
  </SLinkButton>
);

export default LinkButton;
